// Google Analytics 4 utility functions

// Initialize GA4 script if not already loaded
const initializeGA4 = () => {
  if (typeof window === 'undefined') {
    return;
  }

  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  
  if (!measurementId) {
    return; // No GA4 ID configured
  }

  // Check if already initialized
  if (window.gtag) {
    return;
  }

  // Load GA4 script
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script1);

  // Initialize dataLayer and gtag
  window.dataLayer = window.dataLayer || [];
  window.gtag = function() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', measurementId);
};

// Initialize on load
if (typeof window !== 'undefined') {
  initializeGA4();
}

// Check if gtag is available (GA4 script loaded)
const isGA4Available = () => {
  return typeof window !== 'undefined' && typeof window.gtag === 'function';
};

// Track page views
export const trackPageView = (path, title) => {
  if (!isGA4Available()) {
    return;
  }

  window.gtag('config', process.env.REACT_APP_GA_MEASUREMENT_ID, {
    page_path: path,
    page_title: title,
  });
};

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  if (!isGA4Available()) {
    return;
  }

  window.gtag('event', eventName, eventParams);
};

// Track team schedule views
export const trackTeamScheduleView = (teamId, teamName, ageGroup) => {
  trackEvent('view_team_schedule', {
    team_id: teamId,
    team_name: teamName,
    age_group: ageGroup,
  });
};

// Track filter changes
export const trackFilterChange = (filterType, filterValue) => {
  trackEvent('filter_change', {
    filter_type: filterType,
    filter_value: filterValue,
  });
};

